import { useMemo, type PropsWithChildren } from 'react';
import { API_CONFIG } from '@/constants/config';
import { TaskEventStreamContext, type TaskEventStreamConfig } from './TaskEventStreamContext';
import { defaultBackoffPolicy } from './internal/backoffPolicy';
import { createTicketClient } from './internal/ticketClient';
import type { BackoffPolicy, TicketClient } from './types';

interface TaskEventStreamProviderProps {
  baseUrl?: string;
  ticketClient?: TicketClient;
  backoff?: BackoffPolicy;
  heartbeatTimeoutMs?: number;
}

const DEFAULT_HEARTBEAT_TIMEOUT_MS = 60_000;
const defaultTicketClient = createTicketClient();

export function TaskEventStreamProvider({
  children,
  baseUrl = API_CONFIG.BASE_URL,
  ticketClient = defaultTicketClient,
  backoff = defaultBackoffPolicy,
  heartbeatTimeoutMs = DEFAULT_HEARTBEAT_TIMEOUT_MS,
}: PropsWithChildren<TaskEventStreamProviderProps>) {
  const value = useMemo<TaskEventStreamConfig>(
    () => ({
      baseUrl,
      ticketClient,
      backoff,
      heartbeatTimeoutMs,
    }),
    [backoff, baseUrl, heartbeatTimeoutMs, ticketClient]
  );

  return (
    <TaskEventStreamContext.Provider value={value}>{children}</TaskEventStreamContext.Provider>
  );
}
